<template>
  <div class="dialog_warp">
    <div class="search_warp">
      <el-form :model="form" inline>
        <el-form-item label="页面标题">
          <el-input v-model="form.condition"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="button">
      <el-button icon="el-icon-plus" type="primary" @click="add">新增</el-button>
      <el-button icon="el-icon-delete" type="danger" @click="batchDelete">批量删除</el-button>
    </div>
    <!-- 列表 -->
    <el-table class="table_warp" :data="tableData" :max-height="tableHeight"
      @selection-change="val => $handleSelectionChange(val, true)" ref="multipleTable" border>
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column prop="title" label="页面标题" width="200" />
      <el-table-column prop="userClickCount" label="访问人数" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.userClickCount || 0 }}</span>
          <el-button class="ml10" type="text" @click="handleDetail(scope.row)">访问明细</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="updateBy" label="操作员" />
      <el-table-column prop="updateTime" label="更新时间" min-width="150" />
      <el-table-column label="操作" width="420">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" type="primary" @click="editPicture(scope.row)">编辑</el-button>
          <el-button @click="handleCopy(scope.row)">复制路径</el-button>
          <el-popover class="ml10 mr10" placement="right" width="200" trigger="click"
            @show="getQrcode(scope.$index, scope.row)">
            <img :src="scope.row.qrcode" class="code-img" alt=""></img>
            <el-button slot="reference">查看效果</el-button>
          </el-popover>
          <el-button icon="el-icon-delete" type="danger" @click="deletePicture(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination @current-change="pageChange" :total="total" class="mt10" :current-page="form.pageIndex"
      :page-size="form.pageSize" layout="total, prev, pager, next, jumper" />
    <el-dialog v-if="dialogTableVisible" :title="dialogObj.title" :visible.sync="dialogTableVisible" @close="dialogClose">
      <div class="time_title">
        <div class="block">
          <el-date-picker size="mini" v-model="dialogForm.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeDate"
            :picker-options="pickerOptions" :clearable=false>
          </el-date-picker>
        </div>
        <el-table :data="clickCountList" class="mt20">
          <el-table-column property="popDate" label="日期" width="150"></el-table-column>
          <el-table-column property="userCount" label="访问人数" width="200"></el-table-column>
          <el-table-column property="timeCount" label="访问次数"></el-table-column>
        </el-table>
        <el-pagination @current-change="dialogPageChange" :total="dialogForm.total" class="mt10" :current-page="dialogForm.pageIndex"
          :page-size="dialogForm.pageSize" layout="total, prev, pager, next, jumper" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDynamicList, deleteDynamic, getQrcode, getDynamicClickList } from '@/api/mobile'
import { debounce, dictText, copy, isNull, isEmptyArray } from "@/utils/validateBase";
import moment from 'moment';
export default {
  name: 'DialogManage',
  data() {
    return {
      form: {
        condition: '',
        pageIndex: 1, // 当前页
        pageSize: 10, // 显示条数
      },
      total: 0, // 总条数 
      multipleSelection: [], // 被选中行
      tableData: [],
      dialogObj: null,
      dialogTableVisible: false,
      clickCountList: [],
      dialogForm: {
        time: [],
        pageIndex: 1,
        pageSize: 10,
        total:0
      },
      pickerOptions: {

        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]

      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 280;
    this.getList()
  },
  methods: {
    pageChange(page) {
      this.form.pageIndex = page
      this.getList()
    },
    handleSearch: debounce(function () {
      this.form.pageIndex = 1
      this.getList()
    }, true, 800),
    handleReset() {
      this.form.condition = ''
    },
    add() {
      this.$router.push('/backstage/mobile/dynamic_add')
    },
    batchDelete() {
      let ids = []
      if (isEmptyArray(this.multipleSelection)) {
        return this.$message.warning('请选择要删除的项')
      }
      this.multipleSelection.forEach(item => {
        ids.push(item.id)
      })
      this.$confirm('确认删除该数据？').then(_ => { this.handleDelete(ids) }).catch(_ => { });
    },
    deletePicture(row) {
      this.$confirm('确认删除该数据？').then(_ => { this.handleDelete(row.id) }).catch(_ => { });
    },
    async handleDelete(ids) {
      let { code } = await deleteDynamic(ids)
      if (code == 200) {
        this.$message.success('删除成功！')
        this.getList()
      }
    },
    async getList() {
      let { code, data } = await getDynamicList(this.form)
      if (code == 200) {
        this.tableData = data.records || []
        this.total = data.total
      }
    },
    editPicture(row) {
      this.$router.push('/backstage/mobile/dynamic_add?pageId=' + row.id)
    },
    handleCopy(row) {
      let val = `/secondPages/dynamic/dynamic?pageId=${row.id}`
      copy(val)
    },
    getQrcode: debounce(async function (index, row) {
      let { code, data } = await getQrcode({ pageId: row.id })
      if (code == 200) {
        row.qrcode = data
        this.$forceUpdate()
      }
    }, true, 800),
    dialogClose() {
      this.dialogObj = null,
        this.dialogTableVisible = false
    },
    changeDate() {
      this.getDynamicClickList()
    },
    handleDetail: debounce(async function (row) {
      this.dialogObj = row
      this.dialogForm.time = [this.$moment().format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      let flag = await this.getDynamicClickList()
      if(flag){
        this.dialogTableVisible = true
      }
    }, true, 800),
    getDynamicClickList() {
      return new Promise(async (resolve, reject) => {
        let params = {
          pageIndex: this.dialogForm.pageIndex,
          pageSize: this.dialogForm.pageSize,
          condition: {
            pageId: this.dialogObj.id,
            startDate: this.dialogForm.time[0],
            endDate: this.dialogForm.time[1],
          }
        }
        let { code, data } = await getDynamicClickList(params)
        if (code == 200) {
          this.clickCountList = data.records
          this.dialogForm.total = data.total
          resolve(true)
        }else{
          resolve(false)
        }
      })
    },
    dialogPageChange(page){
      this.dialogForm.pageIndex = page
      this.getDynamicClickList()
    }
  },
}
</script>

<style lang="less" scoped>
.code-img {
  width: 200px;
  height: 200px;
}

.dialog_warp {
  height: 100%;
  overflow: auto;

  .search_warp {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .table_warp {
    margin-top: 16px;
  }
}

.el-iamge {
  width: auto;
  height: 100px;
  margin-top: 5px;
}

.upload {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 2px;
  border: 1px dashed #D3D3D5;
  background-color: #FFF;
  color: #9AA0A8;
}
.time_title{
  text-align: center;
}
</style>